import ScriptList from '../pages/script/script_list.vue'//小说剧本列表
import ScriptCreate from '../pages/script/script_create.vue'//小说剧本创建
import ScriptInfo from '../pages/script/script_info.vue'//小说剧本编辑
import ScriptSuccess from '../pages/script/script_success.vue'//小说剧本创建成功中间页面
import ScriptOutline from '../pages/script/script_outline.vue'//小说剧本大纲、章纲管理
import ScriptChapterList from '../pages/script/chapter_list.vue'//小说剧本章节列表
const routes = [
  {
    path: '/scriptList',
    name: 'scriptlist',
    component: ScriptList,
  },
  {
    path: '/scriptCreate',
    name: 'ScriptCreate',
    component: ScriptCreate,
  },
  {
    path: '/scriptInfo',
    name: 'ScriptInfo',
    component: ScriptInfo,
  },
  {
    path: '/scriptSuccess',
    name: 'ScriptSuccess',
    component: ScriptSuccess,
  },
  {
    path: '/scriptOutline',
    name: 'ScriptOutline',
    component: ScriptOutline,
  },
  {
    path: '/scripChaptertList',
    name: 'ScripChaptertList',
    component: ScriptChapterList,
  },
];
export default routes